export const characterCards = [
  {
    id: "29HBJLsttQ3fvXjfk073",
    bgColor2: "#786a97",
    finite: false,
    availableForPurchase: false,
    tokenId: "",
    imageStart:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2Fblitz-start.png?alt=media&token=1fba8063-0b38-4f80-bd63-003d07a4ce33",
    defense: "3",
    imageFin:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2Fblitz-fin.png?alt=media&token=df4387a8-9c5f-4115-9372-1b1379d5d129",
    description:
      "High burst damage potential but needs protection. Accuracy is decent to support high attack",
    attack: "8",
    name: "Blitz",
    attackName: "Riftpiercer",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2FBlitz.png?alt=media&token=6f160028-9fd2-4432-859e-07f1da4c3d78",
    rarity: "Rare",
    price: "",
    bgColor1: "#b21e5e",
    season: "1",
    accuracy: "5",
    collectionName: "Reds, The wilds",
    health: "5",
  },
  {
    id: "2FNidwaGdI8C7jHjS458",
    price: "",
    imageStart:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2Fred-wizaed-start.png?alt=media&token=5ee16fcc-72da-40cf-8bba-2d3e0aa9569a",
    bgColor1: "#ffde41",
    attack: "6",
    tokenId: "",
    attackName: "Burnout",
    imageFin:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2Fred-wizard-fin.png?alt=media&token=ac6e1e21-e371-4c9d-acb9-2afb5ab7fbe3",
    accuracy: "8",
    health: "6",
    availableForPurchase: false,
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2FCluckles.png?alt=media&token=d2eefc9f-6f6e-4dad-b21a-1f24c1f25006",
    name: "Red Wizard",
    collectionName: "Reds, The wilds",
    bgColor2: "#f25c2a",
    description:
      "High accuracy for spellcasting—he doesn't miss. Lower defense reflects fragility",
    rarity: "Legendary",
    defense: "5",
    finite: false,
    season: "1",
  },
  {
    id: "2aGH0t8uaeaagtzexaOH",
    collectionName: "LAMBs",
    rarity: "Common",
    tokenId: "",
    health: "4",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2FAshro.png?alt=media&token=1b0ed64c-a96b-4136-9ef2-e2e4d3fc4a8a",
    accuracy: "4",
    price: "",
    description:
      "Lower defense and health reflect fragility — think of him as a firecracker",
    bgColor1: "#a1200e",
    attack: "7",
    bgColor2: "#141414",
    season: "1",
    finite: false,
    name: "Ashro",
    defense: "3",
    attackName: "Coal Crash",
    availableForPurchase: false,
  },
  {
    id: "5j3yaju2KOeCdqp76L9V",
    attack: "6",
    health: "4",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2Fazuki.png?alt=media&token=1cfeff40-86cd-4bb7-8080-dc09571a03c7",
    rarity: "Common",
    tokenId: "",
    defense: "3",
    price: "",
    collectionName: "Azuki",
    accuracy: "5",
    description:
      "Attack is his standout stat — he’s a blade-wielding firestarter",
    attackName: "Tenkaiken",
    finite: false,
    bgColor2: "#db6d42",
    season: "1",
    availableForPurchase: false,
    bgColor1: "#c13440",
    name: "Tenkao",
  },
  {
    id: "ACb3KaMBodxCj3GlSKGO",
    health: "7",
    availableForPurchase: false,
    imageFin:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2Fsnumbsy-fin.png?alt=media&token=b44cb870-25c8-493b-915a-9bd9fa22f61a",
    defense: "7",
    attackName: "Cryoshard",
    tokenId: "",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2FSnubsy.png?alt=media&token=8ab68e4e-5b7e-4721-a461-1c1bc1321a88",
    season: "1",
    bgColor1: "#a0c6ce",
    imageStart:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2Fsnumbsy-start.png?alt=media&token=76a14a0f-09c2-4f68-b551-aa7564031d18",
    name: "Snubsy",
    collectionName: "Reds (The wilds)",
    rarity: "Rare",
    price: "",
    attack: "4",
    description:
      "Hard to bring down but doesn’t hit very hard. Ideal for stall/control decks",
    finite: false,
    bgColor2: "#1a606a",
    accuracy: "3",
  },
  {
    id: "HuJERluIxiQdrWlsAgNY",
    availableForPurchase: false,
    attackName: "Sprout Shot",
    defense: "4",
    price: "",
    rarity: "Uncommon",
    tokenId: "",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2FTadzo.png?alt=media&token=f6c74df2-d5b3-4526-9a72-947f03b2831a",
    accuracy: "6",
    season: "1",
    description:
      "Agile support/control character — tricky to pin down, not very aggressive, more of a balanced style",
    attack: "4",
    finite: false,
    bgColor2: "#b3a894",
    health: "5",
    name: "Tadzo",
    collectionName: "Tadpoles",
    bgColor1: "#dfd7ca",
  },
  {
    id: "QW8eUlAKTTcLwX7nyKmY",
    imageStart:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2Ftoshi-start.png?alt=media&token=18f14ce4-66d6-4633-9a31-3461fce951b2",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2F546546.png?alt=media&token=b831e028-472a-45cc-8584-7e6e5e8f08e0",
    availableForPurchase: false,
    name: "Toshi",
    bgColor2: "#9ddacd",
    attackName: "Hydro Blade",
    collectionName: "Tadpoles",
    rarity: "Epic",
    health: "7",
    accuracy: "4",
    imageFin:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2Ftoshi-fin.png?alt=media&token=d8ff081d-3b8b-4a27-8ce8-86f60c785fdd",
    attack: "6",
    defense: "6",
    description:
      "Strong frontline presence, but needs to get in close—lower accuracy reflects a need to be strategic",
    tokenId:
      "57896044618658097711785492504343953926634992332820282019728792003956564827517",
    bgColor1: "#06dbb7",
    finite: false,
    price: "",
    season: "1",
  },
  {
    id: "SqmFXIC26tD6QtIk9WV9",
    availableForPurchase: false,
    bgColor1: "#8dc9dd",
    price: "",
    rarity: "Epic",
    defense: "5",
    bgColor2: "#4d57a3",
    accuracy: "8",
    finite: false,
    description:
      "High Accuracy reflects her air-type finesse. Perfect for players who like evasive, hit-and-run tactics or combo setups",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2FTwysper.png?alt=media&token=21aa2f9d-3dce-4bf9-90a6-f5a65a6734f1",
    attack: "6",
    name: "Twysper",
    collectionName: "LAMBs",
    tokenId: "",
    season: "1",
    health: "4",
    attackName: "Airblade Furry",
  },
  {
    id: "c4valX8m50moWrq9MxUm",
    collectionName: "Crypto Meow Meows",
    attack: "4",
    attackName: "Shadow Fang",
    health: "5",
    defense: "5",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2FHexie.png?alt=media&token=da5420c8-6266-4378-8572-dee22b838b6c",
    availableForPurchase: false,
    description:
      "Defense and Health are balanced — she’s not easy to take out, but she can’t brawl forever",
    finite: false,
    name: "Hexie",
    bgColor2: "#fae03a",
    bgColor1: "#f8143c",
    price: "",
    rarity: "Rare",
    tokenId: "",
    accuracy: "7",
    season: "1",
  },
  {
    id: "nnWeD5UzaT2u1rIt7T1V",
    name: "Frostbite",
    tokenId: "",
    price: "",
    defense: "5",
    accuracy: "5",
    health: "6",
    rarity: "Rare",
    description:
      "Solid all-around stats allow Frostbite to keep up pressure and control the pace",
    finite: false,
    attack: "5",
    bgColor1: "#03bcf3",
    availableForPurchase: false,
    bgColor2: "#5595aa",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2FFrostbite.png?alt=media&token=d32d0fb7-069e-4988-ba60-db313876547f",
    collectionName: "BIG Neighbors",
    attackName: "Frozen Fade",
    season: "1",
  },
  {
    id: "oQK0veBoIqdvy870V9JK",
    season: "1",
    bgColor2: "#180647",
    collectionName: "LAMBs",
    health: "5",
    price: "",
    tokenId: "",
    rarity: "Legendary",
    name: "Obscurio",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2FObscurio.png?alt=media&token=e83b6848-4f7b-4773-8ca0-48053729eda9",
    defense: "5",
    attackName: "The Last Laugh",
    bgColor1: "#c6c6c6",
    accuracy: "7",
    finite: false,
    availableForPurchase: false,
    attack: "8",
    description:
      "High Attack and Accuracy make Obscurio terrifying offensively — he hits hard and rarely misses",
  },
  {
    id: "xwn1lYR5kQJUBPvZNYSz",
    accuracy: "5",
    description:
      "Very offensive—good for hit-and-run. Lower survivability but lethal if unchecked",
    attackName: "Void Echo",
    health: "5",
    tokenId: "",
    price: "",
    collectionName: "Reds, The wilds",
    imageStart:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2Fnox-start.png?alt=media&token=a6cf3ccc-fefa-4b5e-a3a6-9b4ce89a2c11",
    season: "1",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2FNox.png?alt=media&token=e744ffb6-cfc3-4320-ab90-662db8c982c5",
    finite: false,
    bgColor2: "#5a595a",
    imageFin:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/NFT%20Images%2Fnox-fin.png?alt=media&token=024797d0-2c3c-4bc1-831f-ec6fdfa7f325",
    availableForPurchase: false,
    rarity: "Epic",
    defense: "5",
    name: "Nox",
    bgColor1: "#b3b1b2",
    attack: "9",
  },
];

export default characterCards;
